import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { DatePipe } from '@angular/common';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { ActivatedRoute, Router } from '@angular/router';
import { EnumIdsTcEstadoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';
import { EnumCodigosTwTcAcciones, EnumIdsTwTcTipoClonacion } from '../../../_importacion/solicitudes/types/enum';
import { TcPerfilUsuarioEnum } from 'src/app/components/core/_infrastructure/types/common';
import { UploadedFileViewModel } from 'src/app/components/core/components/uploader/document_uploader.types';
import { AlegacionExViewModel } from './alegacionEx.types';
import { AlegacionExService } from './alegacionEx.service';
import { TDocumentoSolicitudExViewModel } from '../documentos/documentosEx.types';
import { ConfigurationService } from '../../../core/_infrastructure/classes/services/configuration.service';

@Component({
    selector: 'app-documentoaalegacionex-edit',
    templateUrl: './documentoAlegacionEx-edit.component.html',
})
export class DocumentoAlegacionExEditComponent extends ComponentBase implements OnInit, OnDestroy {
    @HostListener('window:beforeunload', ['$event'])
    forceCheckUnload(): boolean {
        // Prevenimos la pérdida de datos, si el usuario recarga accidentalmente la página.
        // Lo controlamos y el navegador le requiere confirmación para finalizar la recarga.
        if (this.filePendingToPurge !== '') {
            this.alegacionExService.deleteFile(this.filePendingToPurge).subscribe();
        }
        return false;
    }

    editMode = false;
    editTitle = 'Nuevo';

    alegacionEx: AlegacionExViewModel;
    documentoAlegacion: TDocumentoSolicitudExViewModel;
    uploadedFile: UploadedFileViewModel = new UploadedFileViewModel();

    //cols: any[];

    IdEstadoSolicitudEx: number;
    TipoSolicitudExDescripcion: string;
    EstadoSolicitudExDescripcion: string;
    CodigoSolicitud: string;
    CodigoTipoSolicitud: string;
    tituloTipoSolicitud: string;
    IdSolicitudEx: number;
    IdEstadoCertificadoFitoEx: number;
    EstadoCertificadoFitoExDescripcion: string;
    IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    IdSubTipoSolicitudEx: number | null;
    IdSubTipoSolicitudExDescripcion: string;

    habilitarGuardar = true;

    visibilitySpinner = false;
    esClonada = false;

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    private filePendingToPurge = '';
    megaSizeLimit = 0;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public datepipe: DatePipe,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        private alegacionExService: AlegacionExService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        protected configService: ConfigurationService,
    ) {
        super(authService, notificationService, exceptionHandler, configService);

        this.alegacionEx = new AlegacionExViewModel();
        this.documentoAlegacion = new TDocumentoSolicitudExViewModel();
    }

    ngOnInit() {
        this.uploadedFile.OldGuidCollection = new Array<string>();

        this.createForm();

        this.IdSolicitudEx = this.activatedRoute.snapshot.params['id'];
        let idDocumento = this.activatedRoute.snapshot.params['idDocumento'];

        this.guardRefreshPage(this.IdSolicitudEx);

        //EDIT
        if (idDocumento) {
            this.alegacionExService.getDocumento(idDocumento).subscribe(result => {
                this.documentoAlegacion = result;

                this.tituloTipoSolicitud = this.documentoAlegacion.IdTipoSolicitudExDescripcion;
                this.esClonada =
                    this.documentoAlegacion.TwSolicitudJerarquiaEx != null &&
                    this.documentoAlegacion.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;

                //SI ES PREVIA
                if (this.documentoAlegacion.EsPrevia) {
                    if (
                        this.documentoAlegacion.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                        this.documentoAlegacion.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitud += '-Previa';
                    }
                }

                this.CodigoSolicitud = this.documentoAlegacion.CodigoSolicitud;
                this.CodigoTipoSolicitud = this.documentoAlegacion.CodigoTipoSolicitud;
                this.IdEstadoSolicitudEx = this.documentoAlegacion.IdEstadoSolicitudEx;
                this.TipoSolicitudExDescripcion = this.documentoAlegacion.IdTipoSolicitudExDescripcion;
                this.EstadoSolicitudExDescripcion = this.documentoAlegacion.IdEstadoSolicitudExDescripcion;
                this.IdResultadoEnvioMuestrasLaboratorioEx = this.documentoAlegacion.IdResultadoEnvioMuestrasLaboratorioEx;
                this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.documentoAlegacion.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;
                this.IdSubTipoSolicitudEx = this.documentoAlegacion.IdSubTipoSolicitudEx;
                this.IdSubTipoSolicitudExDescripcion = this.documentoAlegacion.IdSubTipoSolicitudExDescripcion;

                this.uploadedFile = { ...this.uploadedFile, Guid: result.CodigoStorage, Name: result.NombreArchivo, Size: result.Size! };

                this.updateForm();

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS,
                    this.documentoAlegacion.IdEstadoSolicitudEx,
                ).Visible;

                if (!this.habilitarGuardar) {
                    this.DisableControlsConsulta();
                } else {
                    this.editMode = true;
                    this.editTitle = 'Editar';
                }
            });
        }
        //ALTA
        else {
            this.alegacionExService.getAlegacionEx(this.IdSolicitudEx).subscribe(result => {
                this.alegacionEx = result;

                this.tituloTipoSolicitud = this.alegacionEx.IdTipoSolicitudExDescripcion;
                this.esClonada =
                    this.alegacionEx.TwSolicitudJerarquiaEx != null &&
                    this.alegacionEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;

                //SI ES PREVIA
                if (this.alegacionEx.EsPrevia) {
                    if (
                        this.alegacionEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                        this.alegacionEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitud += '-Previa';
                    }
                }

                this.CodigoSolicitud = this.alegacionEx.CodigoSolicitud;
                this.CodigoTipoSolicitud = this.alegacionEx.CodigoTipoSolicitud;
                this.IdEstadoSolicitudEx = this.alegacionEx.IdEstadoSolicitudEx;
                this.TipoSolicitudExDescripcion = this.alegacionEx.IdTipoSolicitudExDescripcion;
                this.EstadoSolicitudExDescripcion = this.alegacionEx.IdEstadoSolicitudExDescripcion;
                this.IdEstadoCertificadoFitoEx = this.alegacionEx.IdEstadoCertificadoFitoEx;
                this.EstadoCertificadoFitoExDescripcion = this.alegacionEx.IdEstadoCertificadoFitoExDescripcion;
                this.IdResultadoEnvioMuestrasLaboratorioEx = this.alegacionEx.IdResultadoEnvioMuestrasLaboratorioEx;
                this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.alegacionEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;
                this.IdSubTipoSolicitudEx = this.alegacionEx.IdSubTipoSolicitudEx;
                this.IdSubTipoSolicitudExDescripcion = this.alegacionEx.IdSubTipoSolicitudExDescripcion;
            });
        }

        this.MegaSizeLimitsCargado$.subscribe(() => {
            this.megaSizeLimit = this.getValorSizeLimit('documentoAlegacionEx-edit');
        });
    }

    createForm() {
        this.form = this.fb.group({
            Fecha: '',
            NombreArchivo: ['', Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            Fecha: this.documentoAlegacion.Fecha != null ? new Date(this.documentoAlegacion.Fecha) : null,
            NombreArchivo: this.documentoAlegacion.NombreArchivo,
        });
    }

    private DisableControlsConsulta() {
        this.editTitle = 'Detalle';

        this.form.controls['Fecha'].disable();
        this.form.controls['NombreArchivo'].disable();
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/alegacionEx', this.navMenuService.currentSolicitudExportacion.Id]);
    }

    onFileUploaded(uploadedFile: UploadedFileViewModel) {
        this.uploadedFile = uploadedFile;

        if (this.filePendingToPurge !== '') {
            this.alegacionExService.deleteFile(this.filePendingToPurge).subscribe();
        }
        this.filePendingToPurge = uploadedFile.Guid;

        this.addSuccessMessage('Documento cargado. Recuerde GUARDAR antes de abandonar la pantalla');

        //en Uploader Local obtenemos el valor para este campo obligatorio en subida local
        this.form.controls['NombreArchivo'].setValue(this.uploadedFile!.Name);
    }

    get ficheroSubido(): boolean {
        return this.uploadedFile.Guid !== undefined && this.uploadedFile.Guid !== null && this.uploadedFile.Guid !== '' && !this.uploadedFile.MarkToDelete;
    }

    onFileDeleted(deletedFile: UploadedFileViewModel) {
        this.uploadedFile = deletedFile;
    }

    get formInvalid(): boolean {
        return !this.form.valid || !this.form.dirty || this.form.pristine;
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos del documento');
            return;
        }
        //Validamos si se ha cargado el documento:
        if (this.uploadedFile == null || this.uploadedFile.Name == null) {
            this.addErrorMessage('Debe cargar el documento antes de guardar');
            return;
        }

        this.visibilitySpinner = true;

        let documentoAlegacion = new TDocumentoSolicitudExViewModel();

        documentoAlegacion.Fecha = this.form.value.Fecha;

        documentoAlegacion.IdSolicitudEx = this.IdSolicitudEx;

        documentoAlegacion.Id = this.documentoAlegacion.Id;

        documentoAlegacion.NombreArchivo = this.uploadedFile.Name;
        documentoAlegacion.OldCodigoStorageCollection = this.uploadedFile.OldGuidCollection;
        documentoAlegacion.CodigoStorage = this.uploadedFile.Guid;
        documentoAlegacion.Size = this.uploadedFile.Size;
        documentoAlegacion.EsAlegacion = true;

        documentoAlegacion.IdUsuario = this.loggedInUser!.Id;
        documentoAlegacion.IdTipoDocumentacionEx = 15; //OTROS PENDIENTE HACER ENUMERADO
        documentoAlegacion.IdPais = 60; //ESPAÑA PENDIENTE HACER ENUMERADO

        this.alegacionExService.createDocumento(documentoAlegacion).subscribe({
            next: () => {
                this.addSuccessMessage('Documento añadido correctamente');
                this.visibilitySpinner = false;
                this.filePendingToPurge = '';
                this.onBack();
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinner = false;
            },
        });
    }

    ngOnDestroy(): void {
        if (this.filePendingToPurge !== '') {
            this.alegacionExService.deleteFile(this.filePendingToPurge).subscribe();
        }
    }
}
